import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import "@gwn/ui-design-system-shared/styles/Core.scss";
import "./App.scss";

import { onMounted, onUnmounted } from "vue";

import { authorizationInit } from "@/nurse-console/helpers/authorization";
import { signalingService } from "@/nurse-console/services/signalingService";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(() => {
  /*
    This is a conditional in service of loading the MF in Cerner SMART environment

    The 2 window objects, APPLINK and MPAGES_EVENT, exist when loaded within the Cerner SMART iframe DOM of the Cerner MPage view (If neither returns, then we can bypass the dynamic import of the cerner library.

    In order for the MF DOM view to render appropriately within the Cerner-generated iframe, we have to supply a (desired) static height to the MF DOM, this value is then transferred to the height of the wrapper iframe within the MPage view via the execution of lib method(s)

    More information about the Cerner embeddable lib
    https://github.com/oracle-samples/cerner-smart-embeddable-lib
     */
  if (typeof window.APPLINK !== "undefined" || typeof window.MPAGES_EVENT !== "undefined") {
    import("cerner-smart-embeddable-lib")
      .then(() => {
        console.log("cerner-smart-embeddable-lib imported");
        window.CernerSmartEmbeddableLib = window.CernerSmartEmbeddableLib || {};
        window.CernerSmartEmbeddableLib.calcFrameHeight = function () {
          return 900;
        };
      })
      .catch((error) => {
        console.error("Error loading cerner-smart-embeddable-lib:", error);
      });
  }

  if (window.location.pathname.includes("/expired")) {
    // Do not start the auth workflow
  } else {
    authorizationInit()
      .then(() => {
        console.log("Authorization initialized");
        signalingService.connect("nurse-001");
      })
      .catch((err) => {
        console.error(err);
      });
  }
});

onUnmounted(() => {
  signalingService.disconnect();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }))
}
}

})